import { Badge } from '@/components/ui/badge'
import { INVITATION_STATUS_VARIANTS, type InvitationStatus } from '@/types/users'

const VARIANT_CLASSES: Record<string, string> = {
  blue: 'bg-trilogy-blue/10 text-trilogy-blue hover:bg-trilogy-blue/10',
  indigo: 'bg-trilogy-navy/10 text-trilogy-navy hover:bg-trilogy-navy/10',
  green: 'bg-emerald-100 text-emerald-800 hover:bg-emerald-100',
  amber: 'bg-amber-100 text-amber-800 hover:bg-amber-100',
  red: 'bg-red-100 text-red-800 hover:bg-red-100',
  gray: 'bg-trilogy-gray/10 text-trilogy-gray hover:bg-trilogy-gray/10',
}

/** Invitation status badge with the inviter-facing labels; "—" when there's no invitation. */
export function InvitationStatusBadge({ status }: { status?: InvitationStatus }) {
  if (!status) return <span className="text-sm text-muted-foreground">—</span>
  const v = INVITATION_STATUS_VARIANTS[status] ?? { label: status, variant: 'gray' }
  return <Badge className={VARIANT_CLASSES[v.variant]}>{v.label}</Badge>
}
